import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';
import { decamelize } from '../../../utils/keysConverter';

export default {
  load(params) {
    const url = formUrl('/api/v1/admin/stores');

    return FetchHelpers.get(url, decamelize(params));
  },
};
